export default {
    header: {
        company: "Cuprolli Manufacturing srl",
        vatId: "RO 35671874",
        regCom: "J2016000468359",
        address1: "Strada Caprioarei nr. 11",
        address2: "307200 Ghiroda, jud. Timis",
        bankName: "Banca Transilvania",
        ibanNo: "RO42 BTRL RONC RT03 3757 8301",
        vatRate: "21%",
        validDays: "5"
    },
    dateFormat: "dd.MM.yyyy",
    labels: {
        proforma: "FACTURA  PROFORMA",
        proformaValidity: "Valabilitate factura proforma",
        days: "zile",
        from: "din",
        piece: "buc",
        vatId: "CUI/CIF",
        regCom: "Reg. com",
        bank: "Banca",
        iban: "IBAN",
        client: "Client",
        mrMrs: "Dl/Dna",
        email: "E-mail",
        phone: "Tel",
        vatRate: "Cota TVA",
        vatFree: "Taxare inversa",
        downPayment: "Avans",
        accordingToOfferNo: "conform ofertei nr.",
        no: "Nr",
        productName: "Denumire produs",
        qty: "Cantitate",
        onePrice: "Pret unitare",
        netAmount: "Valoare",
        subtotal: "Total",
        woVat: "fara TVA",
        vat: "TVA",
        total: "TOTAL",
        note1: "",
        note2: ""
    }
}